"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_199)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_199`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#055E1C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.90572 14.3475C6.90572 15.212 7.58993 15.9127 8.43403 15.9127H13.019C13.019 16.633 13.5892 17.2171 14.2926 17.2171H15.8209C16.5243 17.2171 17.0946 16.6331 17.0946 15.9127V14.3475H6.90572ZM17.2217 6.78223V10.4344C17.2217 11.0098 16.7647 11.4778 16.2028 11.4778V13.0431C17.6074 13.0431 18.7499 11.8729 18.7499 10.4344V6.78223H17.2217ZM6.2689 10.4345C6.2689 11.0098 5.81187 11.4779 5.25 11.4779V13.0431C6.65456 13.0431 7.79714 11.8729 7.79714 10.4345V6.7823H6.26883L6.2689 10.4345Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.9293 6.78198H16.4577V10.4342H14.9293V6.78198ZM12.6369 8.86921C12.6369 9.01307 12.5226 9.13007 12.3821 9.13007C12.2416 9.13007 12.1274 9.01307 12.1274 8.86921V6.78219H10.5991V8.86921C10.5991 9.01307 10.4848 9.13007 10.3443 9.13007C10.2039 9.13007 10.0896 9.01307 10.0896 8.86921V6.78219H8.56128V8.86921C8.56128 9.87609 9.36116 10.6953 10.3443 10.6953C10.7229 10.6953 11.0741 10.5734 11.3632 10.3664C11.6521 10.5734 12.0034 10.6953 12.3821 10.6953C12.4583 10.6953 12.5332 10.6898 12.6071 10.6802C12.4988 11.1371 12.0969 11.4779 11.6179 11.4779V13.0431C13.0225 13.0431 14.165 11.8729 14.165 10.4344V6.78219H12.6367L12.6369 8.86921Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.56128 11.4775H10.8535V13.0428H8.56128V11.4775Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_199`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SAFlag };
